import { sentimentVoice } from '../constants';
import myFetchWithId, { exportWithId} from '../helpers/myFetch';
import { secondToDate } from '../helpers/calDate';
import { detailFormatToSample } from '../helpers/dataTransfer';
import { dateAndValue } from '../helpers/dateAndValue';
import { requestFetchApi , receiveFetchApi } from './search.actions';

export function localFetchSentiment(keyword, widgetId, posttype, isDashboard, abb, timeUnit, vocie, sdate, edate) {
    let params = {
      text: keyword,
      fieldname: `glb_sentiment,${timeUnit}`,
      maxcount: -1,
      glb_posttype: posttype,
      fillgap: 'Y',
      score: vocie
    }

    // if we want todo something differently from non dashboard widget, we can add the or remove the params here
    if (isDashboard) {

    }

    return dispatch => {
      isDashboard ? null : dispatch(requestFetchApi())
      return myFetchWithId(widgetId, false, true)(process.env.REACT_APP_LOWI_MULTI, params)
      .then(json =>{
        isDashboard ? null : dispatch(receiveFetchApi(json,widgetId))
        return dispatch(receiveSentimentVoice(json, keyword, abb, timeUnit, sdate, edate))
      })
      .catch(err => {
        isDashboard ? null : dispatch(receiveFetchApi(err,widgetId))
        console.log(err)
      })
    }
}


function receiveSentimentVoice(detailJson, keyword, abb, timeUnit, sdate, edate) {
  if (detailJson.values.tagValues == undefined) {
    return {
      type: sentimentVoice.RECEIVE,
      name: keyword,
      value: [],
      tagCounts: [],
      tableData: [],
      receivedAt: Date.now()
    }
  } 
  else {
    const json = detailFormatToSample(detailJson, true);

    const valueName = abb && abb!==undefined ? decodeURIComponent(abb) : keyword;

    const zeroToOne = (num) => {
      if (num === 0) { return 1;}
      else { return num;}
    };
  
    const negativeObj = json.values.tagValues.NEGATIVE ? json.values.tagValues.NEGATIVE : false;
    const neutralObj = json.values.tagValues.NEUTRAL ? json.values.tagValues.NEUTRAL : false;
    const positiveObj = json.values.tagValues.POSITIVE ? json.values.tagValues.POSITIVE : false;
    
    let postiveValue = dateAndValue(positiveObj, timeUnit, sdate, edate),
        negativeValue = dateAndValue(negativeObj, timeUnit, sdate, edate),
        neutralValue = dateAndValue(neutralObj, timeUnit, sdate, edate),
        totalValue = [],
        pnValue = [],
        tableData = [];
    // Create total object


    // console.log('PNN -=========>', {postiveValue, negativeValue, neutralValue});
    
    for (let i = 0; i < postiveValue.length; i++) {
      for (let j = 0; j < negativeValue.length; j++) {
        if (postiveValue[i].x === negativeValue[j].x) {
          const value = Number((zeroToOne(postiveValue[i].y) / zeroToOne(negativeValue[j].y) ).toFixed(2));
          const value_Out_Check = value > 1.75 ? 1.75 :value
          totalValue.push({ x: postiveValue[i].x, y: postiveValue[i].y + negativeValue[j].y});
          pnValue.push({x: postiveValue[i].x, y: value_Out_Check });
          break;
        }
      }
    }

    for (let i = 0; i < totalValue.length; i++) {
      for (let j = 0; j < neutralValue.length; j++) {
        if (totalValue[i].x === neutralValue[j].x) {
          totalValue[i].y += neutralValue[j].y;
          break;
        }
      }
    }
  
  
    // Create table data
    for (let i = 0; i < neutralValue.length; i++) {
      tableData.push({
        name: valueName,
        time: secondToDate(neutralValue[i].x, '-',timeUnit),
        positive: postiveValue[i].y,
        negative: negativeValue[i].y,
        neutral: neutralValue[i].y,
        total: totalValue[i].y
      });
    }

    return {
      type: sentimentVoice.RECEIVE,
      name: keyword,
      value: [
        { name: '總量-' + valueName, data: totalValue},
        { name: '正向-' + valueName, data: postiveValue},
        { name: '負向-' + valueName, data: negativeValue},
        { name: '中立-' + valueName, data: neutralValue},
        { name: 'pn-' + valueName, data: pnValue }
        // { name: '混合-' + keyword, data: miexed},
      ],
      // pn: { name: 'pn-' + keyword, data: pn},
      tagCounts: [
        {name: '正向-' + valueName, y: json.values.tagCounts.POSITIVE ? json.values.tagCounts.POSITIVE : 0},
        {name: '負向-' + valueName, y: json.values.tagCounts.NEGATIVE ? json.values.tagCounts.NEGATIVE : 0},
        {name: '中立-' + valueName, y: json.values.tagCounts.NEUTRAL ? json.values.tagCounts.NEUTRAL : 0},
        // {name: '總聲量', y: json.values.tagCounts.MIXED + json.values.tagCounts.NEUTRAL + json.values.tagCounts.NEGATIVE + json.values.tagCounts.POSITIVE},
        // {name: '混合', y: json.values.tagCounts.MIXED ? json.values.tagCounts.MIXED : 0},
      ],
      tableData: tableData,
      receivedAt: Date.now()
    }
  }
}

export function exportSentiment(keyword,moreKeywords=false, widgetId, posttype, isDashboard, timeUnit) {

  let params = {
    text: keyword,
    fieldname: `${timeUnit}, glb_sentiment`,
    maxcount: -1,
    glb_posttype: posttype,
    export_kw: moreKeywords ? JSON.stringify(moreKeywords) : '',
    };
    
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (isDashboard) {
    delete params.glb_posttype;
  }
  return exportWithId(widgetId, false, true)(process.env.REACT_APP_EXPORT_COMPLEX, params);
}



// WEBPACK FOOTER //
// ./src/actions/widgetSentiment.actions.js